import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { invalidateMessagesQueryData } from "app/layouts/MainLayout/hooks/useUnreadSupportMessages";
import { useAnalyticsData } from "modules/customerTickets/hooks/useAnalyticsData";
import { FC, useState } from "react";
import { COLOR_BLACK } from "shared/theme/colors";
import { RefreshIcon } from "shared/theme/icons/Refresh";
import Tabs from "./Tabs";
import DataAnalytics from "./Tabs/Content/DataAnalytics";
import Inquiries from "./Tabs/Content/Inquiries";
import { InquiriesAndDataAnalyticsTabs } from "./Tabs/utils";
import { CustomerTicketsPageProvider, useCustomerTicketsPage } from "./context";
import { StyledRefreshButton } from "./styled";

const CustomerTicketsContainer = () => (
  <CustomerTicketsPageProvider>
    <CustomerTickets />
  </CustomerTicketsPageProvider>
);

const CustomerTickets: FC = () => {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [selectedTab, setSelectedTab] = useState(
    InquiriesAndDataAnalyticsTabs.Inquiries,
  );
  const { tableData, loading } = useCustomerTicketsPage();
  const { isLoading: isLoadingAnalyticsData } = useAnalyticsData();

  const handleRefresh = () => {
    setIsRefreshing(true);
    setTimeout(() => {
      setIsRefreshing(false);
    }, 500);
  };
  return (
    <>
      <Box display="flex" justifyContent="space-between" pt={3} px={3}>
        <Typography variant="heading1">Customer Services Centre</Typography>
        <StyledRefreshButton
          onClick={async () => {
            handleRefresh();
            await invalidateMessagesQueryData();
            tableData.refetch();
          }}
        >
          {loading || isLoadingAnalyticsData || isRefreshing ? (
            <CircularProgress sx={{ color: COLOR_BLACK }} size={16} />
          ) : (
            <RefreshIcon />
          )}
        </StyledRefreshButton>
      </Box>
      <Tabs selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
      {selectedTab === InquiriesAndDataAnalyticsTabs.Inquiries && <Inquiries />}
      {selectedTab === InquiriesAndDataAnalyticsTabs.DataAnalytics && (
        <DataAnalytics />
      )}
    </>
  );
};
export default CustomerTicketsContainer;
